import { useTranslation } from "react-i18next";

type PhoneStatus = "online" | "offline" | "busy" | "error";
type AccountStatus = "active" | "suspended" | "deleted" | "pending_validation";
type LogLevel = "debug" | "info" | "warn" | "error";
type JobStatus = "pending" | "running" | "paused" | "completed" | "cancelled" | "error";
type RunStatus = "pending" | "dispatched" | "running" | "success" | "failed" | "cancelled" | "paused";

const STYLES: Record<string, string> = {
  online: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  offline: "bg-ink-700/60 text-ink-500 border-ink-600",
  busy: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  error: "bg-red-500/15 text-red-300 border-red-500/30",

  active: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  suspended: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  deleted: "bg-red-500/15 text-red-300 border-red-500/30",
  pending_validation: "bg-sky-500/15 text-sky-300 border-sky-500/30",

  debug: "bg-ink-700/60 text-ink-500 border-ink-600",
  info: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  warn: "bg-amber-500/15 text-amber-300 border-amber-500/30",

  // Jobs
  pending: "bg-ink-700/60 text-ink-400 border-ink-600",
  running: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  paused: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  completed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  cancelled: "bg-ink-700/60 text-ink-500 border-ink-600",

  // Runs
  dispatched: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  success: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  failed: "bg-red-500/15 text-red-300 border-red-500/30",
};

export function StatusBadge({
  status,
}: {
  status: PhoneStatus | AccountStatus | LogLevel | JobStatus | RunStatus;
}): JSX.Element {
  const { t } = useTranslation();
  const cls = STYLES[status] ?? STYLES.offline;
  // Les libellés viennent de i18n (status.online, status.active, etc.).
  // Si la clé est manquante, i18next renvoie la clé brute → fallback acceptable.
  const label = t(`status.${status}`, { defaultValue: status });
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded-full border ${cls}`}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}
